import { render, staticRenderFns } from "./CalendarNotSetupError.vue?vue&type=template&id=3fb53793"
import script from "./CalendarNotSetupError.vue?vue&type=script&lang=js"
export * from "./CalendarNotSetupError.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports